module.exports = __webpack_public_path__ + "static/media/Scarf_Bones_01.bf63cec4.png";